import { ElectronApi } from '../electron.api';
import { ensureDir } from '@/utils/fs/fs-extra.utils';
import { Description } from '@/types/watchface';
import { xmlToJson } from '@/utils/xmlTool/xmlToJson';
import { descriptionToXML } from '@/utils/xmlTool';
import { cloneDeep } from 'lodash-es';
import generateID from '@/utils/generate-id';
import { getEditorVersion, getWebBuildTime } from '@/utils/version.utils';
import { encodeXmlEntities } from '@/utils/ast/utils/xml.utils';

export class WatchfaceDescription {
  private descriptionXmlPath: string;

  constructor(descriptionXmlPath: string) {
    this.descriptionXmlPath = descriptionXmlPath;
  }

  /**
   * 获取description基本信息
   * @returns
   */
  async getDescriptionData() {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    const descriptionXml = this.descriptionXmlPath;
    if (!descriptionXml) return;

    // 读取description.xml
    try {
      let content = await fs.promises.readFile(descriptionXml, 'utf8');
      if (!content) return;
      content = encodeXmlEntities(content);
      const res = xmlToJson(content) ?? {};
      return res as unknown as Description;
    } catch (error) {
      return;
    }
  }

  /**
   * 写入description文件
   * @param ast 需要写入的ast
   * @returns
   */
  async writeDecsriptionXML(
    description: Description,
    options?: {
      mode: 'create' | 'update';
    }
  ) {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    const data = cloneDeep(description);

    if (data['pkgName'] == undefined) data['pkgName'] = generateID();
    // 需求变更12-27：图片压缩方式由truecolor_alpha->indexed8
    if (data['imageFormat'] == undefined) data['imageFormat'] = 'indexed8';
    if (data['imageCompression'] == undefined) data['imageCompression'] = true;
    data['editorVersion'] = (await ElectronApi.getAppInfo()).version;

    // 添加版本信息
    const webVersion = getWebBuildTime();
    const editorVersion = await getEditorVersion();
    if (options?.mode == 'create') {
      data['webVersionCreatedAt'] = webVersion;
      data['editorVersionCreatedAt'] = editorVersion;
    }
    data['webVersionUpdatedAt'] = webVersion;
    data['editorVersionUpdatedAt'] = editorVersion;

    const xml = descriptionToXML(data, ['address', 'dir']);

    const descriptionXmlPath = this.descriptionXmlPath;
    if (!descriptionXmlPath) return;

    await ensureDir(path.dirname(descriptionXmlPath));
    await fs.promises.writeFile(descriptionXmlPath, xml, 'utf8');

    return xmlToJson(xml) as unknown as Description;
  }
}
